module.exports = __webpack_public_path__ + "static/media/4-cubes-h.89ec4dbe.png";